import * as React from 'react';

import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';
import { range } from 'lodash';

import StyledPopover from '../../../../common/components/StyledPopover';

type Props = {
  handleClose: () => void;
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  handleSelectedItem: (item: number) => void;
  id?: string;
};

const MultiplierPopupMenu: React.FC<Props> = ({
  handleClose,
  anchorEl,
  open,
  handleSelectedItem,
  id,
}) => {
  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
    >
      <MenuList>
        {range(0, 10).map((number) => {
          return (
            <MenuItem
              key={number}
              onClick={() => handleSelectedItem(number + 1)}
            >
              <Typography>{number + 1}x</Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </StyledPopover>
  );
};

export default MultiplierPopupMenu;
